/**
 * Created by fd on 2021-09-22 (13:39).
 */
import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/refurbishing.html";
import InvestmentsView from "../game/components/investments-view";

require("Styles/components/popup/refurbishing.scss");

class RefurbishingView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.team = options.team;
        this.roundData = options.roundData;
        this.market = JSON.parse(this.roundData.market);

        console.log(this.roundData);
        console.log(this.market);

        let hasProductRefurbishing = InvestmentsView.hasPurchasedInvestment(this.team, { title: "product_refurbishing" });

        if (hasProductRefurbishing)
        {
            options.html.find(".popup-subtitle").attr("data-localize", "refurbishing.title");
            options.html.find(".popup-message").attr("data-localize", "refurbishing.description");
        }
        else
        {
            options.html.find(".popup-subtitle").attr("data-localize", "reuse.title");
            options.html.find(".popup-message").attr("data-localize", "reuse.description");
        }

        options.html.find(".resource-button").addClass("not-selectable");

        if (this.market.microchip > 0)
        {
            options.html.find(".microchip").removeClass("not-selectable");
        }
        if (this.market.phone > 0 && this.roundData.resourcePurple > 0)
        {
            options.html.find(".phone").removeClass("not-selectable");
        }
        if (this.market.bike > 0 && this.roundData.resourcePurple > 0)
        {
            options.html.find(".bike").removeClass("not-selectable");
        }

        this.render();
    }

    render()
    {
        super.render();

        this.updateVisibleItems();
        this._setUpEventListeners();
    }

    updateVisibleItems()
    {
        let hasPhone = InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_factory" });
        let hasBike = InvestmentsView.hasPurchasedInvestment(this.team, { title: "bike_factory" });
        let hasProductRefurbishing = InvestmentsView.hasPurchasedInvestment(this.team, { title: "product_refurbishing" });

        this.$element.find(".phone").hide();
        this.$element.find(".bike").hide();

        if (hasProductRefurbishing)
        {
            if (hasPhone)
            {
                this.$element.find(".phone").show();
            }
            if (hasBike)
            {
                this.$element.find(".bike").show();
            }
        }
    }

    getChosenResource()
    {
        let selected = this.$element.find(".selected");

        if (utils.isNotNull(selected))
        {
            return $(selected).data("resource");
        }

        return null;
    }

    _setUpEventListeners()
    {
        let okButton;

        setTimeout(() =>
        {
            okButton = this.$element.closest(".modal-content").find(".dialog-confirm-btn");

            okButton.prop("disabled", true);

            if (buttons.length === 1)
            {
                buttons[0].click();
            }
        }, 1);

        let buttons = this.$element.find(".resource-button:not(.not-selectable)");

        buttons.off("click").on("click", function()
        {
            let btn = $(this);

            buttons.removeClass("selected");
            btn.addClass("selected");

            okButton.prop("disabled", false);
        });
    }
}

module.exports = RefurbishingView;



// WEBPACK FOOTER //
// ./app/js/components/popup/refurbishing.js